"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var logout_controller_1 = __importDefault(require("./logout.controller"));
var logout_html_1 = __importDefault(require("./logout.html"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.logout", {
        url: "/logout",
        controller: "LogoutController",
        controllerAs: "vm",
        template: logout_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("logout", [])
    .config(config)
    .controller("LogoutController", logout_controller_1.default);
